export default __webpack_public_path__ + "static/media/exchange-alt-solid.9653a261.svg";